import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Breadcrumbs, Link, Typography } from '@mui/material';
import { NavigateNext as NavigateNextIcon } from '@mui/icons-material';

interface BreadcrumbItem {
    label: string;
    path: string;
}

// Mapování cest na štítky
const pathLabels: Record<string, string> = {
    admin: 'Admin',
    poplach: 'Vyhlásit poplach',
    udalosti: 'Události',
    users: 'Uživatelé',
    notifications: 'Notifikace',
    statistiky: 'Statistiky',
    reporty: 'Reporty',
    health: 'Zdraví systému',
    audit: 'Audit log',
    configuration: 'Konfigurace',
    specializace: 'Specializace',
    technika: 'Technika',
    kontroly: 'Kontroly',
    dostupnost: 'Dostupnost',
    pohotovost: 'Pohotovost',
    hydranty: 'Hydranty',
    sablony: 'Šablony poplachu',
    devices: 'Zařízení',
    sessions: 'Aktivní relace',
    akce: 'Akce',
    iot: 'IoT',
    objekty: 'Objekty',
    zarizeni: 'Evidence zařízení',
    'senzor-typy': 'Typy senzorů',
    nastaveni: 'Nastavení',
};

const AdminBreadcrumbs: React.FC = () => {
    const location = useLocation();

    // Rozdělíme path na segmenty
    const pathnames = location.pathname.split('/').filter((x) => x);

    // Vytvoříme breadcrumbs
    const breadcrumbs: BreadcrumbItem[] = [];

    pathnames.forEach((segment, index) => {
        const path = `/${pathnames.slice(0, index + 1).join('/')}`;

        // Přeskočíme root
        if (segment === 'admin' && index === 0) {
            breadcrumbs.push({ label: 'Dashboard', path: '/admin' });
            return;
        }

        // Pokud je to ID (číslo), přidáme "Detail #ID"
        if (/^\d+$/.test(segment)) {
            breadcrumbs.push({ label: `Detail #${segment}`, path });
            return;
        }

        // Jinak použijeme mapování nebo segment samotný
        const label = pathLabels[segment] || segment;
        breadcrumbs.push({ label, path });
    });

    // Pokud jsme jen na /admin, nezobrazujeme breadcrumbs
    if (breadcrumbs.length <= 1) {
        return null;
    }

    return (
        <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="navigace"
            sx={{ mb: 2 }}
        >
            {breadcrumbs.map((crumb, index) => {
                const isLast = index === breadcrumbs.length - 1;

                if (isLast) {
                    return (
                        <Typography key={crumb.path} color="text.primary">
                            {crumb.label}
                        </Typography>
                    );
                }

                return (
                    <Link
                        key={crumb.path}
                        component={RouterLink}
                        to={crumb.path}
                        underline="hover"
                        color="inherit"
                    >
                        {crumb.label}
                    </Link>
                );
            })}
        </Breadcrumbs>
    );
};

export default AdminBreadcrumbs;
